package ai.wagemix.pages

import ai.wagemix.di.koin
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.navigate
import ai.wagemix.siteStrings
import ai.wagemix.web.screens.appshell.WMDefaultAppShellWebViewModel
import ai.wagemix.web.screens.auth.WMAuthForm
import ai.wagemix.web.screens.auth.WMAuthScreen
import ai.wagemix.web.screens.auth.WMDefaultAuthWebViewModel
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.fsryan.foundation.web.screens.FSWebScreen
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.text.SpanText
import org.koin.core.parameter.parametersOf

@Composable
private fun authPage(ctx: PageContext, form: WMAuthForm, workflow: String, actionCode: String? = null) {
    val next = ctx.route.params["next"] ?: ""
    WMAuthScreen(
        createViewModel = {
            koin.get<WMDefaultAuthWebViewModel> {
                parametersOf(workflow, next, { request: WMNavigationRequest -> ctx.navigate(request) })
            }
        },
        form = form,
        strings = siteStrings,
        actionCode = actionCode
    )
}

@Page(routeOverride = "login")
@Layout(".components.layouts.AuthLayout")
@Composable
fun LoginPage(ctx: PageContext) = authPage(ctx, WMAuthForm.Login, workflow = "login")

@Page(routeOverride = "register")
@Layout(".components.layouts.AuthLayout")
@Composable
fun RegisterPage(ctx: PageContext) = authPage(ctx, WMAuthForm.Register, workflow = "register")

@Page(routeOverride = "forgot-password")
@Layout(".components.layouts.AuthLayout")
@Composable
fun ForgotPasswordPage(ctx: PageContext) = authPage(ctx, WMAuthForm.ForgotPassword, workflow = "reset")

/** Firebase's action link lands here with `mode` and `oobCode` (see the password-reset rollout note). */
@Page(routeOverride = "auth-action")
@Layout(".components.layouts.AuthLayout")
@Composable
fun AuthActionPage(ctx: PageContext) {
    val mode = ctx.route.params["mode"]
    val code = ctx.route.params["oobCode"]
    when (mode) {
        "resetPassword" -> authPage(ctx, WMAuthForm.ResetPassword, workflow = "reset", actionCode = code)
        "verifyEmail" -> authPage(ctx, WMAuthForm.VerifyEmail, workflow = "verify", actionCode = code)
        else -> SpanText(siteStrings.sharedMix.invalidTitle)
    }
}

/** Signs out through the shell presenter, which routes home once the sync completes. */
@Page(routeOverride = "logout")
@Composable
fun LogoutPage(ctx: PageContext) {
    FSWebScreen(createViewModel = {
        koin.get<WMDefaultAppShellWebViewModel> { parametersOf({ request: WMNavigationRequest -> ctx.navigate(request) }) }
    }) { vm ->
        LaunchedEffect(Unit) { vm.userRequestedSignOut() }
        SpanText(siteStrings.common.loading)
    }
}
